import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderCheckboxPipe } from './order-checkbox.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [OrderCheckboxPipe],
    exports: [OrderCheckboxPipe]
})
export class SharedPipesModule { }



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/pipes/shared-pipes.module.ts